import React from 'react';
import Counter from '../../components/Counter';
import ButtonTwo from '../../components/Button/ButtonTwo';

import aboutImg from '../../assets/img/about/about-5-1.jpg';
import aboutImg2 from '../../assets/img/about/about-5-2.jpg';
import shapeImg from '../../assets/img/about/shape-5-1.png';

const About = () => {
  return (
    <div id="it-about" className="it-about-5-area fix pt-120 pb-150">
      <div className="container container-1520 ">
        <div className="row align-items-center">
          <div className="col-xl-5 col-lg-5 order-1 order-lg-0">
            <div className="it-about-5-thumb">
              <img src={aboutImg} alt="" />
            </div>
          </div>
          <div className="col-xl-7 col-lg-7 order-0 order-lg-1">
            <div className="it-about-5-right p-relative">
              <div className="it-about-5-shape-1 d-none d-lg-block">
                <img src={shapeImg} alt="" />
              </div>
              <div className="it-about-2-title-box mb-30">
                <span className="it-section-subtitle red-border">About us</span>
                <h3 className="it-section-title d-block">
                  Leading the Way in Lifesaving <br /> Cardiology Solutions.
                </h3>
              </div>

              <div className="row align-items-center align-items-xl-end">
                <div className="col-xl-7 col-lg-7 col-md-7">
                  <div className="it-about-5-content">
                    <p className="mb-30">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do <br />
                      eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim <br /> ad minim veniam, quis nostrud
                      exercitation ullamco laboris nisi ut aliquip ex ea commodo
                      consequat. Duis aute irure dolor
                    </p>
                    <div className="it-about-5-client-wrap d-flex align-items-center">
                      <div className="it-about-5-client-item style-1">
                        <span className="about-funfact-title">
                          01. Clients consulted
                        </span>
                        <i className="about-funfact-number">
                          <Counter
                            start={0}
                            end={532}
                            duration={2}
                            counterSubText={'+'}
                          />
                        </i>
                      </div>
                      <div className="it-about-5-client-item style-2">
                        <span className="about-funfact-title">
                          02. Success clients
                        </span>
                        <i className="about-funfact-number">
                          <Counter
                            start={0}
                            end={95}
                            duration={5}
                            counterSubText={'%'}
                          />
                        </i>
                      </div>
                    </div>
                    <div className="it-slider-button mt-35">
                      <ButtonTwo
                        btnURL="/about-us"
                        btnClass="it-btn-theme red-bg mr-35"
                        btnText="Discover More"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xl-5 col-lg-5 col-md-5">
                  <div className="it-about-5-thumb-sm text-end">
                    <img src={aboutImg2} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
